import {
  NEW_VENUE_REQUEST,
  NEW_VENUE,
  NEW_VENUE_ERROR,
  GET_VENUE_REQUEST,
  GET_VENUE,
  GET_VENUE_ERROR,
  GEO_REQUEST,
} from '../actions/types'

var initialState = {
  venue: {},
  loading: true,
  error: {},
  geolookup: false,
}

export default function(state = initialState, action) {
  switch (action.type) {
    case NEW_VENUE_REQUEST:
      return {
        ...state,
        loading: action.payload.loading,
      }
    case NEW_VENUE:
      return {
        ...state,
        venue: action.payload.venue,
      }
    case NEW_VENUE_ERROR:
      return {
        ...state,
        error: action.payload.error,
      }
    case GET_VENUE_REQUEST:
      return {
        loading: action.payload.loading,
      }
    case GET_VENUE:
      return {
        loading: action.payload.loading,
        item: action.payload.venue,
      }
    case GET_VENUE_ERROR:
      return {
        ...state,
        loading: action.payload.loading,
        error: action.payload.error,
      }
    case GEO_REQUEST:
      return {
        ...state,
        geolookup: action.payload.geolookup,
      }
    default:
      return {...state}
  }
}



/** WEBPACK FOOTER **
 ** ./src/reducers/venue_reducer.js
 **/